angular.module('core')
  .service('edxFtueService', [
    '$modal',
    'authentication',
    'dblAnalyticsProvider',
    'edxCustomerSettingsService',
    'dblUserAgent',
    'configuration',
    function(
      $modal,
      authentication,
      dblAnalytics,
      edxCustomerSettingsService,
      dblUserAgent,
      $configuration
    ) {
    var self = this;

    function openModal(){
      var modal = $modal.open({
        templateUrl: 'resources/components/ftue/edx-ftue-page.component.html',
        windowClass: 'common-modal ftue-modal',
        controller: 'EdxFtuePageController',
        backdrop: false,
        keyboard: true,
        resolve: {
        }
      });
      var authCustomer = authentication.getCustomer();
      if (authCustomer !== null) {
        dblAnalytics.eventTrack('FTUE Launched', {
          category: 'FTUE',
          eventType: 'auto',
          label: 'customer-' + authCustomer.id
        });

      }
    }

    self.popFtue = function() {
      if (
        !authentication.isGuardian(authentication.getCustomer()) &&
        !edxCustomerSettingsService.getHideFtue() &&
        !$configuration.isTrue('application.FTUE.hide') &&
        !dblUserAgent.hasMobileWidth()
      ) {
        openModal();
      }
    };
  }]);
